"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechHistoryItemResponseModelVoiceCategory = void 0;
exports.SpeechHistoryItemResponseModelVoiceCategory = {
    Premade: "premade",
    Cloned: "cloned",
    Generated: "generated",
    Professional: "professional",
};
